import React from "react";
import '../../css/StatusBadge.css';

const statusConfig = {
  draft: { text: "پیش‌نویس", color: "gray" },
  published: { text: "منتشر شده", color: "green" },
  archived: { text: "آرشیو", color: "orange" }
};

export default function StatusBadge({ status }) {
  const config = statusConfig[status] || { text: status, color: "gray" };
  
  return (
    <span className={`status-badge ${config.color}`}>
      {config.text}
    </span>
  );
}